import React from 'react'

const IMSWorkDaySelector = (props) => {
    const { selectedWorkMode, setSelectedWorkMode } = props;
  return (
    <div className='dropdown me-2'>
                        <button
                            className='btn btn-outline-secondary dropdown-toggle'
                            type='button'
                            data-bs-toggle='dropdown'
                            aria-expanded='false'
                        >
                            {selectedWorkMode}
                        </button>
                        <ul className='dropdown-menu'>
                            <li>
                                <button className='dropdown-item' onClick={() => setSelectedWorkMode('Work Day')}>
                                    Work Day
                                </button>
                            </li>
                            <li>
                                <button className='dropdown-item' onClick={() => setSelectedWorkMode('History')}>
                                    History
                                </button>
                            </li>
                        </ul>
                    </div>
  )
}

export default IMSWorkDaySelector